export const GET_COUNTRIES = `
  query   {
    countries {
      id
      name
      isoCode
    }
  }
`;

export const ALL_PORTS_QUERY = `
  query {
    ports {
      id
      relationshipOfficer {
        name
        role {
          name
        }
      }
      relationshipManager {
        name
        role {
          name
        }
      }
    }
  }
`;

export const UPDATE_VESTING_RULE = `
  mutation UpdateVestingRule($id: ID!, $vestingType: String, $flatPercentage: Float, $year0: Float, $year1: Float, $year2: Float, $year3: Float, $year4: Float, $year5: Float, $year6: Float, $year7: Float, $year8: Float, $year9: Float, $year10: Float, $vestingDateType: String) {
    updateVestingRule(id: $id, vestingType: $vestingType, flatPercentage: $flatPercentage, year0: $year0, year1: $year1, year2: $year2, year3: $year3, year4: $year4, year5: $year5, year6: $year6, year7: $year7, year8: $year8, year9: $year9, year10: $year10, vestingDateType: $vestingDateType) {
      errors {
        property
        description
      }
      vestingRule {
        id
        vestingType
        flatPercentage
        year0
        year1
        year2
        year3
        year4
        year5
        year6
        year7
        year8
        year9
        year10
        vestingDateType
      }
    }
  }
`;

export const DELETE_VESTING_RULE = `
  mutation DeleteVestingRule($id: ID!) {
    deleteVestingRule(id: $id) {
      result
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_VESTING_RULE = `
mutation CreateVestingRule($companySubscriptionId: ID!, $vestingType: String!, $flatPercentage: Float, $year0: Float, $year1: Float, $year2: Float, $year3: Float, $year4: Float, $year5: Float, $year6: Float, $year7: Float, $year8: Float, $year9: Float, $year10: Float, $vestingDateType: String) {
  createVestingRule(companySubscriptionId: $companySubscriptionId, vestingType: $vestingType, flatPercentage: $flatPercentage, year0: $year0, year1: $year1, year2: $year2, year3: $year3, year4: $year4, year5: $year5, year6: $year6, year7: $year7, year8: $year8, year9: $year9, year10: $year10, vestingDateType: $vestingDateType) {
    errors {
      property
      description
    }
    vestingRule {
      id
      vestingType
      flatPercentage
      year0
      year1
      year2
      year3
      year4
      year5
      year6
      year7
      year8
      year9
      year10
      vestingDateType
    }
  }
}
`;

export const CREATE_CUSTOMER_VESTING_RULE = `
mutation CreateCustomerVestingRule($customerId: ID!, $companySubscriptionId: ID!, $vestingType: String!, $flatPercentage: Float, $vestingDateType: String!, $source: String!, $year0: Float, $year1: Float, $year2: Float, $year3: Float, $year4: Float, $year5: Float, $year6: Float, $year7: Float, $year8: Float, $year9: Float, $year10: Float) {
  createCustomerVestingRule(customerId: $customerId, companySubscriptionId: $companySubscriptionId, vestingType: $vestingType, flatPercentage: $flatPercentage, vestingDateType: $vestingDateType, source: $source, year0: $year0, year1: $year1, year2: $year2, year3: $year3, year4: $year4, year5: $year5, year6: $year6, year7: $year7, year8: $year8, year9: $year9, year10: $year10) {
    errors {
      property
      description
    }
    customerVestingRule {
      id
      customerId
      companySubscriptionId
      vestingType
      flatPercentage
      year0
      year1
      year2
      year3
      year4
      year5
      year6
      year7
      year8
      year9
      year10
      vestingDateType
    }
  }
}
`;

export const LOG_SELF_SERVICE_ACTIVITIES = `
  mutation LogSelfServiceActivity($petraId: String!, $description: String!, $channel: String!, $category: String!, $subCategory: String!) {
    logSelfServiceActivity(petraId: $petraId, description: $description, channel: $channel, category: $category, subCategory: $subCategory) {
      errors {
        description
        property
      }
      selfServiceActivity {
        category
        channel
        customer{
          petraId
        }
        description
        id
        subCategory
      }
    }
  }
`;

export const CREATE_NOTE = `
  mutation CreateNote($userId: ID!, $description: String!) {
    createNote(userId: $userId, description: $description){
       note {
        id
        description
        user {
          id
        }
      }
      errors {
          property
          description
      }
    }
  }
`;

export const CREATE_ATTACHMENT = `
  mutation CreateAttachment($url: String!, $name: String) {
    createAttachment(url: $url, name: $name){
       attachment {
        id
        url
        name
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_TRUSTEES = `
query {
  trustees {
    id
    name
    trusteeSchemes {
      id
      name
      trusteeContactPerson {
        id
        firstName
        firstName
        middleName
        lastName
        email
        phoneNumber
      }
    }
  }
}
`;

export const GET_FINANCIAL_INSTITUTIONS = `
query {
  financialInstitutions {
    id
    name
    institutionType
    bankBranches {
      id
      name
      sortCode
    }
  }
}
`;

export const GET_CATEGORIES = `
query Categories ($departmentId: ID!, $forPurpose: String){
  categories (departmentId: $departmentId, forPurpose: $forPurpose) {
    id
    name
    subCategories {
      id
      name
    }
  }
}
`;

export const MARK_ADDRESS_AS_PRIMARY = `
mutation MarkAddressAsPrimary($addressId: ID!) {
  markCustomerAddressAsPrimary(id: $addressId){
    customerAddresses {
      id
      address {
        id
        streetName
        poBox
        ghPost
        region
        city
        country {
          id
          name
        }
      }
      isPrimary
      isActive
    }
  }
}`;

export const MARK_EMAIL_AS_PRIMARY = `
mutation MarkEmailAsPrimary($emailId: ID!) {
  markCustomerEmailAsPrimary(id: $emailId){
    customerEmails {
      id
      email {
        id
        address
      }
      isPrimary
      isActive
    }
  }
}`;

export const MARK_PHONE_AS_PRIMARY = `
mutation MarkAddressAsPrimary($phoneId: ID!) {
  markCustomerPhoneAsPrimary(id: $phoneId){
    activeCustomerPhones {
      id
      phone {
        id
        number
        type
      }
      isPrimary
      isActive
    }
  }
}`;

export const CREATE_ADDRESS = `
  mutation CreateAddress($streetName: String, $poBox: String, $city: String!, $addressCountry: ID!, $isPostalBox: Boolean, $ghPost: String, $region: String!) {
    createAddress(streetName: $streetName, poBox: $poBox, city: $city, countryId: $addressCountry, isPostalBox: $isPostalBox, ghPost: $ghPost, region: $region){
      address {
        id
        streetName
        poBox
        city
        ghPost
        region
        country {
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_EMAIL = `
  mutation CreateEmail($address: String!) {
    createEmail(address: $address){
      email {
        id
        address
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_PHONE = `
  mutation CreatePhone($number:String!) {
    createPhone(number: $number){
      phone {
        id
        number
        type
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_MARITAL_STATUSES = `
  query {
    maritalStatuses {
      id
      name
    }
  }
`;

export const GET_ID_TYPES = `
query {
  idTypes {
    id
    name
  }
}
`;

export const GET_TITLES = `
query {
  titles {
    id
    name
  }
}
`;

export const GET_TAGS = `
query GetTags($forCustomer: Boolean, $forCompany: Boolean, $forAccount: Boolean, $forProduct: Boolean){
  tags(forCustomer: $forCustomer, forCompany: $forCompany, forAccount: $forAccount, forProduct: $forProduct) {
    id
    name
  }
}
`;

export const DELETE_FILE = `
mutation DeleteFile($id: ID!) {
  deleteFileUpload(id: $id){
    result
    errors {
      property
      description
    }
  }
}
`;

export const GET_CUSTOMER_RELATIONSHIPS = `
query {
  customerRelationships {
    id
    name
  }
}
`;

export const VALIDATE_PHONE_NUMBER_QUERY = `
query ValidatePhoneNumberQuery($phoneNumber: String!) {
  validatePhoneNumber(number: $phoneNumber)
}
`;

export const GET_INDUSTRY_SECTORS = `
query {
  industrySectors {
    id
    name
  }
}
`;

export const GET_TRUSTEES_SUMMARY = `
query {
  trustees {
    id
    name
  }
}
`;

export const ALL_AUDITABLE_TYPES_QUERY = `
  query {
    auditableModels
  }
`;

export const GET_AUDITS = `
query filteredAudits($page: ID, $action: String, $auditableType: String, $userId: ID, $period: String) {
  audits(page: $page, action: $action, auditableType: $auditableType, userId: $userId, period: $period) {
    count
    values {
      id
      auditableId
      auditableType
      action
      auditedChanges
      customerId
      user {
        name
        email
      }
      createdAt
    }
  }
}
`;

export const GET_AUDIT_QUERY = `
  query GetAudit($id:ID!) {
    audit(id: $id ){
      id
      auditableId
      auditableType
      action
      auditedChanges
      customerId
      user {
        name
        email
      }
      createdAt
    }
  }
`;

export const CURRENT_PERIOD_QUERY = `
  query {
    currentPeriod
  }
`;

export const GET_CHANGE_REQUESTS = `
  query {
    changeRequests {
      action
      entityId
      entityType
      proposedChanges
      petraId
      isApproved
      requestedBy {
        id
        name
      }
    }
  }
`;

export const GET_CURRENT_PERIOD = `
  query {
    currentPeriod
  }
`;

export const SYNC_PRICES = `
mutation SyncPricesManually($productId: ID) {
  syncPricesManually(productId: $productId) {
    result
  }
}
`;

export const GET_ENTITLEMENTS = `
  query {
    entitlements {
      id
      name
      relatedModel
    }
  }
`;

export const EXCLUSION_LIST_QUERY = `
  query {
    exclusionLists {
      id
      name
      statementType
      exclusionListType
    }
  }
`;

export const CREATE_EXCLUSION_LIST = `
  mutation CreateExclusionList($name: String!, $statementType: String!, $exclusionListType: String!, $description: String!) {
    createExclusionList(name: $name, statementType: $statementType, exclusionListType: $exclusionListType, description: $description){
      exclusionList {
        id 
        name
        statementType
        exclusionListType
        description
        companies {
          id
          name
          petraId
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_EXPORTED_DATA = `
query GetExportedData(
  $page: Int!
  $numberPerPage: Int
  $filters: ExportDataFilterInput
  $orderBy: ExportDataOrderByInput
) {
  getExportedData(
    page: $page
    numberPerPage: $numberPerPage
    filters: $filters
    orderBy: $orderBy
  ) {
    count
    results {
      id
      name
      status
      url
      failureReason
      createdAt
      user {
        id
        name
      }
      exportField {
        id
        name
        model
        fields
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_EXPORT_DATA_STATUS_ENUM = `
{
  __type(name: "ExportDataStatusEnum") {
    enumValues {
      name
      description
    }
  }
}
`;

export const GET_EXPORT_DATA_SORT_FIELDS = `
{
  __type(name: "ExportDataSortFieldEnum") {
    enumValues {
      name
      description
    }
  }
}
`;

export const GET_SERVICES = `
query Services($departmentId: ID!){
    services(departmentId: $departmentId){
        name  
        id
    }
}
`;

export const GET_QPR_REPORTS = `
  query GetqprReports($page: ID!, $numberPerPage: ID, $qprType: String, $productId: ID, $quarter: String, $year: String, $companyId: ID) {
    getQprReports(page: $page, numberPerPage: $numberPerPage, qprType: $qprType, productId: $productId, quarter: $quarter, year: $year, companyId: $companyId) {
      count
      results {
        id
        name
        status
        createdAt
        url
        notificationSent
      }
    }
  }
`